//@ts-check
// @ts-ignore
import App from './app.riot';
import { closeDialog } from '@/common/components/kf-dialog';
import { connect } from '@/common/lib/riot-redux';
import { loginRequest, loginSuccess, loginFailure } from '../login/login.action';
import { ajaxPost } from '../ajax';
import { router } from '@riotjs/route';
import dupOwnerLogin from './dup-owner-login';

const mapStateToProps = (state, props) => ({
  loader: state.loader,
  dialog: state.dialog,
  base: props.base
});

const mapDispatchToProps = (dispatch) => ({
  closeDialog() {
    dispatch(closeDialog());
  },

  async autoLogin(route) {
    const mail = decodeURIComponent(route.searchParams.get('mail'));
    const password = decodeURIComponent(route.searchParams.get('password'));
    dispatch(loginRequest());
    try {
      const data = await ajaxPost('/login', { 
        method: 'login', 
        mail, 
        password 
      });
      if (data.isAdmin) {
        location.href = '/admin/#';
      } else {
        await dupOwnerLogin(mail);
        location.href = '/owner/#';
      }
      dispatch(loginSuccess(data));
    } catch (e) {
      dispatch(loginFailure(e));
      router.push('login');
    }
  }
});

export default connect(App, mapStateToProps, mapDispatchToProps);